<template>
  <div class="TimesheetDatesHeader">
    <ul
      v-if="weeks.length > 1"
      class="nav nav-tabs"
    >
      <li
        v-for="(week, index) in weeks"
        :key="week.ordinal"
        :class="{ active: week.active }"
        @click.prevent="activeWeekIndex = index"
      >
        <a>{{ week.ordinal }} week</a>
      </li>
    </ul>
    <div class="buttons">
      <AppButton
        v-for="date in datesGroupedByWeek[activeWeekIndex]"
        :key="date.iso8601"
        v-tooltip="{ delay: 0 }"
        class="pill"
        :title="date.tooltip"
        :active="date.active"
        :disabled="date.disabled"
        @click="$emit('change-date', date.iso8601)"
      >
        {{ date.label }}
      </AppButton>
    </div>
  </div>
</template>

<script>
import { chunk, times, compact } from 'lodash-es';
import AppButton from '~/components/AppButton.vue';

export default {
  name: 'TimesheetDatesHeader',
  components: { AppButton },
  props: {
    startDate: {
      type: String,
      required: true,
    },
    endDate: {
      type: String,
      required: true,
    },
    availableDates: {
      type: Array,
      required: true,
    },
    currentDate: {
      type: String,
      default: null,
    },
  },
  emits: ['change-date'],
  data: () => ({
    activeWeekIndex: 0,
  }),
  computed: {
    datesGroupedByWeek() {
      const currentDate = moment();
      const days = moment(this.endDate).diff(this.startDate, 'days') + 1;
      const dates = times(days, (day) => {
        const date = moment(moment(this.startDate).add(day, 'days'));
        const iso8601 = date.format('YYYY-MM-DD');
        const disabled = !this.availableDates.includes(iso8601);

        if (date.isAfter(currentDate)) {
          return null;
        }

        return {
          iso8601,
          disabled,
          active: iso8601 === this.currentDate,
          tooltip: disabled ? 'No screenshots captured on this date' : null,
          label: date.format('MMM DD'),
        };
      });

      return chunk(compact(dates), 7);
    },
    weeks() {
      return this.datesGroupedByWeek.map((_, index) => ({
        active: index === this.activeWeekIndex,
        ordinal: moment.localeData().ordinal(index + 1),
      }));
    },
  },
  created() {
    this.activeWeekIndex = this.datesGroupedByWeek.findIndex((dates) =>
      dates.map((d) => d.iso8601).includes(this.currentDate),
    );
  },
};
</script>
